import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="currentColor"
      {...props}
    >
      <path d="m24 21.879 15.44-15.44a1.5 1.5 0 0 1 2.224 2.008l-.103.114L26.12 24l15.44 15.44a1.5 1.5 0 0 1 .103 2.007l-.103.114a1.5 1.5 0 0 1-2.008.103l-.114-.103L24 26.12 8.56 41.561a1.5 1.5 0 0 1-2.007.103l-.114-.103a1.5 1.5 0 0 1-.103-2.008l.103-.114L21.88 24 6.439 8.56a1.5 1.5 0 0 1-.103-2.007l.103-.114a1.5 1.5 0 0 1 2.008-.103l.114.103zl15.44-15.44z" />
    </svg>
  );
}

export default Icon;
